import moment from 'moment';
import actionType from '../actions/clean/actionType';

const timeFormatStr = 'YYYY-MM-DD HH:mm:ss';

export interface IguestInfo {
  id: number;
  createTime: string; // 置脏时间
  roomNo: string; // 房号
  type: number | string; // 清洁类型
  status: number | string; // 清洁状态
  urgentLevel: number | string; // 是否紧急
  cleanerNames: string; // 实际完成清洁人员
  cleanByName: string; // 完成清洁人员
  cleanTime: number; // 最后清洁时间
  reworkCount: number; // 返工次数
  pieceCount: number; // 计件数量
  checkByName: string; // 最后检查人员
  checkTime: string; // 最后检查时间
  cleanRemark: string; // 置净备注
  rework: number; // 是否返工
}
export interface Ipagination {
  endRow?: number;
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
  isFirstPage?: boolean;
  isLastPage?: boolean;
  navigateFirstPage?: number;
  navigateLastPage?: number;
  navigatePages?: number;
  navigatepageNums?: Array<number>;
  nextPage?: number;
  pageNum?: number;
  pageSize?: number;
  pages?: number;
  prePage?: number;
  size?: number;
  startRow?: number;
  total?: number;
  rework?: null;
  searchValue?: Object;
}

const initialState: CleanInitialStateProps = {
  cleanList: [],
  cleanListLoading: false,
  searchValue: {
    rework: null, // 是否返工（0：否，1：是）
    pageNum: 1,
    pageSize: 50,
    // 置脏时间
    createTimeStart: null,
    createTimeEnd: null,
    // 清洁时间
    startCleanTime: null,
    endCleanTime: null,
    // startCleanTime: moment(new Date()).subtract(1, 'month').valueOf(),
    // endCleanTime: moment(new Date()).valueOf(),
    employeeNo: null, // 清洁人员工号
    status: null, // 清洁状态列表（1：待检查,3：已完成，4：已取消）

    // statusList: [],
    // leaveStatus: null,
    // cleanerName: null,
  },
  total: 0,
};

export interface CleanInitialStateProps extends Ipagination {
  cleanList: Array<IguestInfo>;
  cleanListLoading: boolean;
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.CLEAN_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.TOGGLE_LOADING:
      return {
        ...state,
        cleanListLoading: action.payload,
      };
    case actionType.SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: {
          ...state.searchValue,
          ...action.payload,
        },
      };
    case actionType.RESET_PAGINATION:
      return {
        ...state,
        searchValue: {
          rework: null, // 是否返工（0：否，1：是）
          pageNum: 1,
          pageSize: 50,
          // 置脏时间
          createTimeStart: null,
          createTimeEnd: null,
          // 清洁时间
          startCleanTime: null,
          endCleanTime: null,
          employeeNo: null, // 清洁人员工号
          status: null, // 清洁状态列表（1：待检查,3：已完成，4：已取消）
        },
      };
    default:
      return {
        ...state,
        ...action.payload,
      };
  }
};
